import React from 'react'
import styles from './text-area.module.scss'

interface IProps {
  label?: string
  modifiers?: string
  readOnly?: boolean
  placeholder?: any
  error?: boolean
  handleInputChange: any
  resetError?: any
  handleValidation?: () => (val) => void
  name: any
  value: any
}

const TextArea = React.memo(function TextArea(props: IProps) {

  const handleChange = (value: string) => {
    props.handleInputChange()(value)
  }


  const handleBlur = () => {
    if (props.handleValidation && props.value) {
      props.handleValidation()(props.value)
    }
  }

  return (
    <div className={`${styles.inputField} ${props.modifiers ? props.modifiers : ''}`}>
      {props.label && <label htmlFor={props.name} className={styles.inputLabel}>{props.label}</label>}
        <textarea
          id={props.name}
          className={`${styles.input} ${props.error ? styles.errorState : ''}`}
          placeholder={props.placeholder}
          readOnly={props.readOnly}
          disabled={props.readOnly}
          onBlur={handleBlur}
          value={props.value ? props.value : ''}
          onFocus={() => props.resetError ? props.resetError() : {}}
          onChange={(e) => handleChange(e.target.value)}
          cols={30} rows={1} />
    </div>
  )
})

export default TextArea